<template>
  <el-tooltip effect="dark" placement="right" :content="isActive ? '点击折叠菜单': '点击展开菜单'">
    <div class="hamburger" :class="{'is-active':isActive}" @click="toggleClick">
      <i class="QS-icon-caret-right"></i>
    </div>
  </el-tooltip>
</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    toggleClick: {
      type: Function,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
$--color-primary: #276BEC;
$--color-white: #FFFFFF;
.hamburger {
  width: 12px;
  height: 32px;
  border-radius: 0 4px 4px 0;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  background: $--color-white;
  cursor: pointer;

  i {
    color: $--color-primary;
    font-size: 12px;
    text-align: center;
    line-height: 32px;
    transform: rotate(0deg);
  }

  &:hover i{
    color: #79A2F1;
  }

  &.is-active {
    background: $--color-primary;
    i {
      color: $--color-white;
      transform: rotate(180deg);
    }

    &:hover {
      background: #5087ED;
    }
  }
}
</style>
